import { toDecimalString } from "../../../utils/numbers";

export const hasTotalColumns = (columnDefs) => columnDefs.some((c) => c.ipkTotalizar);
export const getTotalColumnsDefs = (columnDefs) => columnDefs.filter((c) => c.ipkTotalizar);
export const extractPinnedBottomDataSchema = (columnDefs) => {
  //return getTotalColumnsDefs(columnDefs).reduce((p, c) => {
  return columnDefs.reduce((p, c) => {
    p[c.field] = c.ipkDefaultValue;
    return p;
  }, {});
};

export const initializePinnedBottom = (columns, initialData) => {

  if (!initialData) {
    return hasTotalColumns(columns) ? [extractPinnedBottomDataSchema(columns)] : null;
  }

  return initialData;
};

export const getPinnedBottom = (columns, rows, pinnedBottomRowData) => {
  if (!pinnedBottomRowData) {
    const newPinned = hasTotalColumns(columns) ? recalculatePinnedBottom(getTotalColumnsDefs(columns), rows) : null;
    return newPinned !== null ? [newPinned] : newPinned;
  }

  return pinnedBottomRowData;
};

//Se recalculan únicamente los datos numérico con el type: numericColumn
const recalculatePinnedBottom = (columns, rows) => {
  const keys = [];
  let calculados = {};
  //inicializar totales

  columns.forEach((c) => {
    keys.push(c.field.toString());
    Object.defineProperty(calculados, c.field, { value: 0.0, enumerable: true, configurable: true, writable: true });
  });

  let pinned = extractPinnedBottomDataSchema(columns);

  //Calcular totales
  rows.forEach((r) => {
    const { data } = r;
    keys.forEach((k) => {
      calculados[k] += data[k];
    });
  });

  //formatear totales
  keys.forEach((k) => {
    if (toDecimalString(calculados[k]) === "NaN") {
      calculados[k] = 0;
    }

    toDecimalString(calculados[k]);
  });

  return { ...pinned, ...calculados };
};
